import * as React from 'react';

import { UIHeading2, UIHeading3 } from '@cian/ui-kit';
import { clsx } from 'clsx';
import * as styles from './HeaderLayoutMobile.css';
import { usePromoSelectionEnabled } from '../../../hooks/promoOffersSelection';

export interface IHeaderLayoutMobileProps {
  backButton: React.ReactNode;
  chips: React.ReactNode;
  plate: React.ReactNode;
  searchInput: React.ReactNode;
  sorting: React.ReactNode;
  title: React.ReactNode;
  tags: React.ReactNode;
  promoOffers: React.ReactNode;
  isFixedHeaderShown: boolean;
}

export const HeaderLayoutMobile = React.forwardRef<HTMLDivElement, IHeaderLayoutMobileProps>((props, ref) => {
  const { backButton, chips, plate, searchInput, sorting, title, tags, promoOffers, isFixedHeaderShown } = props;

  const isPromoOffersEnabled = usePromoSelectionEnabled();

  return (
    <>
      <div className={styles['title-row']}>
        {backButton}
        <UIHeading3 as="h1">{title}</UIHeading3>
        <div className={styles['sorting']}>{sorting}</div>
      </div>
      <div className={styles['search']} ref={ref}>
        {searchInput}
        <div className={styles['chips']}>{chips}</div>
        <div className={styles['tags']}>{tags}</div>
      </div>
      <div className={styles['promo-offers']}>{promoOffers}</div>
      <div className={styles['plate']}>
        {isPromoOffersEnabled && <UIHeading2>{title}</UIHeading2>}
        {plate}
      </div>
      {isFixedHeaderShown && (
        <div className={styles['fixed-header']} data-testid="FixedHeader">
          <div className={clsx(styles['title-row'], styles['title-row--fixed'])}>
            <div className={styles['title--controls']}>
              {backButton}
              <UIHeading3 as="h1">{title}</UIHeading3>
            </div>
            <div className={styles['title--controls']}>
              {searchInput}
              <div className={styles['sorting']}>{sorting}</div>
            </div>
          </div>
          <div className={styles['search']}>
            <div className={styles['chips']}>{chips}</div>
            <div className={styles['tags']}>{tags}</div>
          </div>
        </div>
      )}
    </>
  );
});

HeaderLayoutMobile.displayName = 'HeaderLayoutMobile';
